import { Fragment, useState, useRef, useLayoutEffect } from 'react';
import { TableRowCollapseButton } from './components/TableRowCollapseButton';
import { TableRow } from '../TableRow/TableRow';
import { TableCollapseBodyCell, TableCollapseRow, StyledTableBodyCell } from './styled';
export function TableRowCollapse(props) {
    const { children, colSpan, dropdownContent, expandibleHeaders, hideDropdownOnBreakpoint } = props;
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const [buttonWidth, setButtonWidth] = useState(0);
    useLayoutEffect(() => {
        var _a;
        const { width = 0 } = ((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {};
        setButtonWidth(width);
    }, []);
    return (<Fragment>
      <TableRow $expanded={open}>
        <StyledTableBodyCell $hideOnBreakpoint={hideDropdownOnBreakpoint} headers={expandibleHeaders}>
          <TableRowCollapseButton ref={buttonRef} open={open} onClick={() => setOpen(!open)}/>
        </StyledTableBodyCell>
        {children}
      </TableRow>
      {open && (<TableCollapseRow $hideOnBreakpoint={hideDropdownOnBreakpoint}>
          <TableCollapseBodyCell $offset={buttonWidth} headers={expandibleHeaders} colSpan={colSpan}>
            {dropdownContent}
          </TableCollapseBodyCell>
        </TableCollapseRow>)}
    </Fragment>);
}
